// utils/firebaseUtils.js

import { db } from '@/firebase';
import { doc, setDoc, getDoc } from 'firebase/firestore';

/**
 * 사용자 설정을 Firestore에 저장하는 함수
 * @param {string} userId - 사용자 UID
 * @param {object} settings - 저장할 설정 객체
 */
export async function saveUserSettings(userId, settings) {
  try {
    const userRef = doc(db, 'users', userId);
    await setDoc(userRef, { settings }, { merge: true });
    // console.log('설정이 저장되었습니다.');
  } catch (error) {
    console.error('설정 저장 중 오류 발생:', error);
    throw error;
  }
}

/**
 * 사용자 정보 및 기본 설정을 Firestore에 저장하는 함수
 * @param {string} userId - 사용자 UID
 * @param {object} userInfo - 저장할 사용자 정보 객체
 * @param {object} settingsData - 저장할 설정 기본값 객체
 */

export async function saveUserAndSettings(userId, userInfo, settingsData) {
  try {
    const userRef = doc(db, 'users', userId);
    await setDoc(
      userRef,
      {
        ...userInfo,
        settings: settingsData,
      },
      { merge: true }
    );
    // console.log('사용자 정보와 설정이 저장되었습니다.');
  } catch (error) {
    console.error('사용자 정보 및 설정 저장 중 오류 발생:', error);
    throw error;
  }
}

/**
 * Firestore에서 사용자 설정을 불러오는 함수
 * @param {string} userId - 사용자 UID
 * @returns {object|null} - 불러온 설정 객체 또는 null
 */
export async function getUserSettings(userId) {
  try {
    const docRef = doc(db, 'users', userId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data();
      if (data.settings) {
        // console.log('설정을 불러왔습니다:', data.settings);
        return data.settings;
      }
      // console.log('설정이 존재하지 않습니다.');
      return null;
    }
    // console.log('사용자 문서가 존재하지 않습니다.');
    return null;
  } catch (error) {
    console.error('설정 불러오기 중 오류 발생:', error);
    throw error;
  }
}
